import React, { memo } from 'react';
import { useDropzone } from 'react-dropzone';
import { UploadDocumentAcceptedTypesStringConstants } from '../../../common/constants';
const DragAndDrop = ({ onDrop, accept, fileUpload, name, t, inline = false, isAllowFullDrag = false, disabled = false, summaryPage = false, }) => {
  // Initializing useDropzone hooks with options
  const { getRootProps, getInputProps } = useDropzone({
    onDrop,
    accept,
  });

  return isAllowFullDrag ? (
    <>
      {/* drag and drop files */}
      <div className={`custom__add-section mt-4 mb-5 ${disabled ? 'disableDiv' : ''}`} {...(!disabled ? getRootProps() : {})}>
        <div className="mt-4 border border-box-stroke py-12 mb-6">
          <div className="custom__add-section self-end">
            <div className="custom__add-section mt-4 mb-5">
              <div className="w-[733px] absolute mr-4 h-[125px] top-[-25px] left-[-30px] opacity-40 hover:bg-[#FFFAEB] hover:border hover:border-primary-yellow rounded"></div>
              <div className='dropzone-div' >
                <input
                  className='dropzone-input'
                  {...getInputProps()}
                  ref={fileUpload}
                  type='file'
                  name={name}
                  id={name}
                  aria-label='Upload Document'
                  multiple
                  accept={UploadDocumentAcceptedTypesStringConstants}
                />
                <div>
                  <p className='dropzone-content' style={{ textAlignLast: !inline ? 'center' : '' }}>
                    {t('DropFile')}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </>
  ) : (
    <>
      {/* drag and drop files */}
      <div className='dropzone-div' {...getRootProps()}>
        <input
          className='dropzone-input'
          {...getInputProps()}
          ref={fileUpload}
          type='file'
          name={name}
          id={name}
          aria-label='Upload Document'
          multiple
          accept={UploadDocumentAcceptedTypesStringConstants}
        />
        <div>
          <p className={`dropzone-content ${summaryPage ? "ml-2" : ""}`} style={{ textAlignLast: !inline ? 'center' : '' }}>
            {t('DropFile')}
          </p>
        </div>
      </div>
    </>)
};
export default memo(DragAndDrop);
